<template>
  <div class="pt-1 pb-0" v-show="activity.AppointmentDate">
    <!-- <h3>Select a time</h3> -->

    <p
      v-if="!totalGuestInActivity || !activity.AppointmentDate"
      class="bg-gray pl-2 pr-2 pt-1 pb-1 border_radius flex_start"
    >
      <!-- <i class="material-icons mr-1">priority_high</i>  -->
      Add guests and select a date to see available times.
    </p>

    <pre>
activity.EntityHierarchyKey: {{
        activity.EntityHierarchyKey
          ? activity.EntityHierarchyKey
          : "MISSING!!!!!!"
      }}</pre
    >

    <ul class="simple_time list times" v-if="totalGuestInActivity">
      <times-ui-row
        v-for="time in activity.Times"
        :key="'times-ui-activity-times-' + time.Value"
        :id="activity.EntityHierarchyKey + '-activity-times-' + time.Value"
        :value="time.Value"
        :activity="activity"
        :isPrivateTour="activity.IsPrivateTour"
        :name="radioName"
        :time="time"
        @input="updateInput"
        :isPackage="isPackage"
        :showAllTimes="showAllTimes"
        :isLoading="isLoading"
        :entityHierarchyKey="entityHierarchyKey"
        :hideUnselectedTimes="hideUnselectedTimes"
        @showUnselectedTimes="$emit('showUnselectedTimes')"
        @didSelectBook="didSelectBook"
      />
    </ul>
  </div>
</template>

<script>
import TimesUiRow from "../components/TimesUiRow.vue";
import { mapActions } from "vuex";

//import postTimeSelection from "../mixins/postTimeSelection.js";

export default {
  name: "TimesUI",
  props: [
    "isLoading",
    "radioName",
    "activity",
    "totalGuestInActivity",
    "isPackage",
    "showAllTimes",
    "addToCartObject",
    "hideUnselectedTimes",
    "entityHierarchyKey",
  ],

  // mixins: [postTimeSelection],

  components: {
    TimesUiRow
  },
  computed: {
    hasAddons() {
      return this.activity.HasAddons;
    }
  },

  methods: {
    ...mapActions(["goToAddons"]),
    didSelectBook: function (value) {
      this.$emit('didSelectBook', value)
    },
    updateInput: function(val) {
      //console.log("updateInput(val) ", val);

      if (this.activity.Times) {
        // set all the not selected
        this.activity.Times.forEach(ele => {
          if (ele.Value != val) {
            ele.IsSelected = false;
            //this.$set(ele, "AddOns", null);
            setTimeout(() => {
              //ele.AddOns = false;
            }, 1000);
          }
        });

        // find the time the user selected
        var find = this.activity.Times.find(ele => {
          return ele.Value == val;
        });

        // set it to selected
        find.IsSelected = true;
        //this.$emit("input", event.target.value);

        //this.advancePostTimeSelection("simpleTime", val);

        // if (this.hasAddons) {
        //   //
        //   this.goToAddons({
        //     productType: "activity",
        //     entityHierarchyKey: this.activity.EntityHierarchyKey,
        //     timeId: val
        //   });
        // }
        // //
        // else {
        //   console.log(
        //     "I do not have addons so emit a SelectedTimeChanged event."
        //   );
        //   //this.$set(ele, "AddOns", null);

        //   this.$emit("selectedTimeChanged", true);
        // }
      }
    }
  }
};
</script>

<style></style>
